import React from "react";
import { Box, Card, Grid, styled, Typography, Paper } from "@mui/material";
import CountUp from "react-countup";
import HourglassFullRoundedIcon from "@mui/icons-material/HourglassFullRounded";
import AddTaskRoundedIcon from "@mui/icons-material/AddTaskRounded";
import DoDisturbOnRoundedIcon from "@mui/icons-material/DoDisturbOnRounded";
import PendingActionsRoundedIcon from "@mui/icons-material/PendingActionsRounded";

const StyledCard = styled(Card)(({ theme }) => ({
  "&.MuiCard-root": {
    [theme.breakpoints.down("sm")]: {
      padding: "16px !important",
      flexDirection: "row",
      gap: "10px",
    },

    padding: "25px",
    borderRadius: "15px",
    display: "flex",
    flexDirection: "column",
    alignContent: "space-between",
    boxShadow: "0 0 8px 2px rgba(0,0,0,0.1) !important",
  },
}));

function StatCards({ getApi }) {
  const approved = getApi.filter((i) => i.status === "A" || i.status === "S").length;
  const pending = getApi.filter((i) => i.status === "P").length;
  const declined = getApi.filter((i) => i.status === "D").length;
  const total = getApi.length;

  const cardList = [
    {
      name: "Total Registration",
      count: total,
      color: "#339fcd",
      icon: <HourglassFullRoundedIcon />,
    },
    {
      name: "Total Approved",
      count: approved,
      color: "#10b981", // Modern green
      icon: <AddTaskRoundedIcon />,
    },
    {
      name: "Total Declined",
      count: declined,
      color: "#ef4444", // Modern red
      icon: <DoDisturbOnRoundedIcon />,
    },
    {
      name: "Total Pending",
      count: pending,
      color: "#f59e0b", // Modern amber/orange
      icon: <PendingActionsRoundedIcon />,
    },
  ];

  return (
    <Grid container spacing={3}>
      {cardList.map((item, index) => (
        <Grid item xs={12} sm={6} md={3} key={index}>
          <Paper
            elevation={0}
            sx={{
              p: 3,
              borderRadius: "24px",
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              background: `linear-gradient(135deg, ${item.color} 0%, ${item.color}bb 100%)`,
              color: 'white',
              boxShadow: `0 10px 20px -5px ${item.color}44`,
              transition: "transform 0.3s ease",
              '&:hover': {
                transform: "translateY(-5px)",
                boxShadow: `0 15px 30px -5px ${item.color}66`,
              }
            }}
          >
            <Box>
              <Typography variant="caption" sx={{ fontWeight: 700, textTransform: 'uppercase', letterSpacing: 1, opacity: 0.9, fontSize: '0.65rem' }}>
                {item.name}
              </Typography>
              <Typography variant="h4" sx={{ fontWeight: 800, mt: 0.5 }}>
                <CountUp start={0} end={item.count} duration={1} />
              </Typography>
            </Box>
            <Box sx={{
              p: 1.5,
              borderRadius: "14px",
              backgroundColor: "rgba(255,255,255,0.25)",
              color: "white",
              display: 'flex',
              backdropFilter: "blur(4px)"
            }}>
              {React.cloneElement(item.icon, { fontSize: 'medium' })}
            </Box>
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
}

export default StatCards;
